export const BEEP_LOSING = 'BEEP_LOSING';
export const BEEP_BUTTON_PRESS = 'BEEP_BUTTON_PRESS';
export const BEEP_COUNTDOWN = 'BEEP_COUNTDOWN';
export const FEEDBACK_NAVIGATION = 'FEEDBACK_NAVIGATION';
export const SAY_ONE = 'SAY_ONE';
export const SAY_TWO = 'SAY_TWO';
export const SAY_THREE = 'SAY_THREE';



// WEBPACK FOOTER //
// ./src/feedback/FeedbackTypes.js